<template>
  <div class="whxq">
    <div class="banner-wrap" style="backgroundImage: url(images/whxq/banner5.png);"></div>
    <div class="con-wrap">
      <img src="images/whxq/1.png" alt="">
      <img src="images/whxq/2.png" alt="">
      <img src="images/whxq/3.png" alt="">
      <img src="images/whxq/4.jpg" alt="">
      <img src="images/whxq/5.png" alt="">
      <!-- <img src="images/whxq/6.jpg" alt=""> -->
      <img src="images/whxq/7.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'whxq',
  data() {
    return {
      bannerimg: './images/whxq/banner.jpg'
    }
  }
}
</script>

<style lang="scss" scoped>
.whxq {
  // display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 80px;
}
.banner-wrap {
  width: 800px;
  height: 500px;
  margin: 0 auto;
  // background-image: url(../../public/images/whxq/banner.jpg);
  background-size: cover;
  // background-position: -90px 48px;
  background-position: -55px 42px;
}

.con-wrap {
  width: 800px;
  margin: auto;
  img {
    width: 100%;
  }
}
</style>